const RESERVED_SUBDOMAINS = new Set(["admin", "api", "app", "www"]);
const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "0.0.0.0", "::1"]);

function cleanDomain(value) {
  return (value || "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/\/.*$/, "")
    .replace(/\.$/, "");
}

function isIpAddress(hostname) {
  return /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname);
}

function isReservedSubdomain(value) {
  return RESERVED_SUBDOMAINS.has(value);
}

function isLocalHostname(hostname) {
  return LOCAL_HOSTNAMES.has(hostname) || isIpAddress(hostname);
}

export function getConfiguredEventRootDomain() {
  return cleanDomain(process.env.REACT_APP_EVENT_ROOT_DOMAIN) || "jabburelias.com.br";
}

export function getConfiguredAdminHostname() {
  const configuredAdminHostname = cleanDomain(process.env.REACT_APP_ADMIN_HOSTNAME);
  if (configuredAdminHostname) {
    return configuredAdminHostname;
  }

  const configuredRootDomain = getConfiguredEventRootDomain();
  return configuredRootDomain ? `admin.${configuredRootDomain}` : null;
}

export function getEventExternalUrlFromHostname(hostname = window.location.hostname) {
  const normalizedHostname = cleanDomain(hostname);
  if (!normalizedHostname || isLocalHostname(normalizedHostname)) {
    return null;
  }

  const adminHostname = getConfiguredAdminHostname();
  if (adminHostname && normalizedHostname === adminHostname) {
    return null;
  }

  const configuredRootDomain = getConfiguredEventRootDomain();
  if (configuredRootDomain) {
    if (normalizedHostname === configuredRootDomain) {
      return normalizedHostname;
    }

    if (!normalizedHostname.endsWith(`.${configuredRootDomain}`)) {
      return normalizedHostname;
    }

    const subdomain = normalizedHostname.slice(0, -(configuredRootDomain.length + 1));
    if (!subdomain || subdomain.includes(".") || isReservedSubdomain(subdomain)) {
      return null;
    }

    return normalizedHostname;
  }

  const labels = normalizedHostname.split(".");
  if (labels.length < 3 || isReservedSubdomain(labels[0])) {
    return null;
  }

  return normalizedHostname;
}

export function isAdminHostname(hostname = window.location.hostname) {
  const normalizedHostname = cleanDomain(hostname);
  if (!normalizedHostname || isLocalHostname(normalizedHostname)) {
    return true;
  }

  const adminHostname = getConfiguredAdminHostname();
  return !!adminHostname && normalizedHostname === adminHostname;
}

function withConfiguredProtocol(hostname) {
  const configuredProtocol = process.env.REACT_APP_EVENT_ROOT_PROTOCOL || window.location.protocol || "https:";
  const protocol = configuredProtocol.endsWith(":") ? configuredProtocol : `${configuredProtocol}:`;
  return `${protocol}//${hostname}`;
}

export function buildAdminUrl(path = "/") {
  const adminHostname = getConfiguredAdminHostname();
  if (!adminHostname) {
    return path;
  }

  return `${withConfiguredProtocol(adminHostname)}${path}`;
}

export function buildPublicEventUrl(eventOrSlug) {
  const slug = typeof eventOrSlug === "string" ? eventOrSlug : eventOrSlug?.slug;
  const urlExterna = typeof eventOrSlug === "string" ? null : cleanDomain(eventOrSlug?.urlExterna);

  if (urlExterna) {
    return withConfiguredProtocol(urlExterna);
  }

  if (!slug) return "#";

  const encodedSlug = encodeURIComponent(slug);
  return `/e/${encodedSlug}`;
}

export function buildGuestConfirmationUrl(evento, codigoConfirmacao) {
  const version = Date.now();
  const encodedCode = encodeURIComponent(codigoConfirmacao);
  const urlExterna = cleanDomain(evento?.urlExterna);

  if (urlExterna) {
    return `${withConfiguredProtocol(urlExterna)}/${encodedCode}?v=${version}`;
  }

  if (evento?.slug) {
    return `${withConfiguredProtocol(getConfiguredEventRootDomain())}/e/${encodeURIComponent(evento.slug)}?convite=${encodedCode}&v=${version}`;
  }

  return `${withConfiguredProtocol(getConfiguredEventRootDomain())}/${encodedCode}?v=${version}`;
}
